var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelpIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.583,
    height: 14.583,
    viewBox: "0 0 14.583 14.583",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.292 14.583a7.292 7.292 0 1 1 7.292-7.292 7.3 7.3 0 0 1-7.292 7.292zm0-4.375a.729.729 0 1 0 .729.729.73.73 0 0 0-.729-.728zm-.127-5.832a1.6 1.6 0 0 1 .262.022 1.474 1.474 0 0 1 1.261 1.437c0 .337-.274.693-.793 1.028a4.472 4.472 0 0 1-.667.352c-.069.03-.137.058-.2.083l-.084.03a.729.729 0 0 0 .45 1.387 5.793 5.793 0 0 0 1.3-.628 2.7 2.7 0 0 0 1.458-2.252A2.925 2.925 0 0 0 7.666 2.96a3.065 3.065 0 0 0-.5-.041A2.982 2.982 0 0 0 4.357 4.86a.729.729 0 1 0 1.371.5l.045-.109a1.526 1.526 0 0 1 1.392-.875z",
    transform: "translate(0 0) translate(0 0)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/Help-Icon.3f22fd816b45efe72bf21cdf756db00c.svg";
export { ForwardRef as ReactComponent };